module.exports = __webpack_public_path__ + "static/media/route-interstate.5b415c73.svg";